import { Badge } from '@/shared/ui/badge'

import { type FC } from 'react'

import type { TabsBadgeProps } from './types'

/**
 * Tab badge (to be used in Tabs.Cell)
 */
export const TabsBadge: FC<TabsBadgeProps> = ({ children, type = 'neutral' }) => {
  return <Badge type={type} label={String(children)} variant="soft" />
}

TabsBadge.displayName = 'TabsBadge'
